/**
 * Select2 Spanish translation
 */
(function ($) {
    "use strict";

    if(bq.config.locale == 'es') {
        $.extend($.fn.select2.defaults, {
            formatNoMatches: function () {
                return "No se encontraron resultados";
            },
            formatInputTooShort: function (input, min) {
                var n = min - input.length;
                return "Por favor adicione " + n + " caracter" + (n == 1 ? "" : "es");
            },
            formatInputTooLong: function (input, max) {
                var n = input.length - max;
                return "Por favor elimine " + n + " caracter" + (n == 1 ? "" : "es");
            },
            formatSelectionTooBig: function (limit) {
                return "Solo puede seleccionar " + limit + " elemento" + (limit == 1 ? "" : "s");
            },
            formatLoadMore: function (pageNumber) {
                return "Cargando más resultados...";
            },
            formatSearching: function () {
                return "Buscando...";
            }
        });
    }
})(jQuery);